const locale = (name, params) => {
	params = params || {};
	var text = locale.getDictionary(locale.currentLocaleName)[name] || locale.getDictionary(locale.defaultLocaleName)[name] || '';
	return text.replace(/{([-_\w\d]+)}/gi, function(found, parameterName) {
		return params[parameterName] || '';
	});
};

locale.currentLocaleName = 'ru';
locale.defaultLocaleName = 'ru';
locale.dictionary = {};

locale.getDictionary = (localeName) => {
	localeName = localeName || locale.defaultLocaleName;
	if(!locale.dictionary[localeName]) {
		try {
			locale.dictionary[localeName] = require('./' + localeName + '.js').default;
		} catch(e) {
			locale.dictionary[localeName] = {};
			console.error(`cant load locale "${localeName}"`);
		}
	}

	return locale.dictionary[localeName];
};

locale.setLocale = (localeName) => {
	locale.getDictionary(localeName);
	locale.currentLocaleName = localeName;
	return locale;
};

locale.setLocale(locale.defaultLocaleName);
locale.field = (object, field) => {
	const initialField = field;
	const currentLocale = locale.currentLocaleName;
	field = `${initialField}_${currentLocale}`;
	if (object.hasOwnProperty(field)) {
		return object[field];
	}

	field = `${initialField}${currentLocale.charAt(0).toUpperCase() + currentLocale.slice(1)}`;
	if (object.hasOwnProperty(field)) {
		return object[field];
	}

	if (object.hasOwnProperty(initialField)) {
		return object[initialField];
	}

	return null;
}


export default locale;
